import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ApiwrapperService } from 'src/app/services/apiwrapper.service';
import { DataManipulationService } from 'src/app/services/data-manipulation.service';

@Injectable({
  providedIn: 'root'
})
export class ToServiceService {

  constructor(private api: ApiwrapperService, private data: DataManipulationService) {  }

  getTOTeams(daysInterval: any, indicator: string, sort: string, pageNumber: number, limit: number, teams: any): Observable<any> {
    return this.api.getTeamsOverviewTeams(daysInterval, indicator, sort, pageNumber, limit, teams);
  }

  getTeams(): Observable<any[]> {
    return of(this.data.userTeams());
  }

  getMemberActivity(teamUuid: string): Observable<any> {
    return this.api.getMemberActivity(teamUuid);
  }

  removeMemberFromTeam(memberUuid: any, teamUuid: any): Observable<any> {
    return this.api.deleteTeamMember(memberUuid, teamUuid);
  }

  removeMemberFromWorkspace(memberUuid: any): Observable<any> {
    return this.api.deleteWorkspaceUser(memberUuid);
  }
  
  getIndicatorInterval(): Observable<any> {
    return this.api.getIndicatorInterval();
  }

  getTeamActivePollingDetails(teamUuid: any): Observable<any> {
    return this.api.getTeamActivePolling(teamUuid);
  }

  pauseTeamActivePolling(teamUuid: any, pollUuid: any, status: any): Observable<any> {
    return this.api.patchActivePolling(pollUuid, teamUuid, {status});
  }

  getAggregatedScores(teams: any): Observable<any> {
    return this.api.getTeamsOverviewAggregatedScores(teams);
  }

  searchWorkspaceMemberForViewShare(searchValue: string): Observable<any> {
    return this.api.getSearchWorkspaceMember(searchValue);
  }

  getMemberTeamsForViewConfirmation(memberUuid: string): Observable<any> {
    return this.api.getUserTeams(memberUuid);
  }

  getTOViews(): Observable<any> {
    return this.api.getTeamsOverviewViews();
  }

  getViewByUuid(viewUuid: string): Observable<any> {
    return this.api.getViewByUuid(viewUuid);
  }

  createView(viewBody: any): Observable<any> {
    return this.api.createView(viewBody);
  }

  patchView(viewUuid: string, viewBody: any): Observable<any> {
    return this.api.patchUserView(viewUuid, viewBody);
  }

  deleteView(viewUuid: string): Observable<any> {
    return this.api.deleteView(viewUuid);
  }

  shareViewWithUser(sharedBody: any): Observable<any> {
    return this.api.shareViewWithUser(sharedBody);
  }

  getUsersForSharedView(viewUuid: string): Observable<any> {
    return this.api.getSharedViewUsers(viewUuid);
  }

  removeShareFromUser(userUuid: any): Observable<any> {
    return this.api.removeSharedViewFromUser(userUuid);
  }

  getUserAvailableTeams(): Observable<any> {
    return this.api.getUserAvailableTeams();
  }
}
